


































import { Component, Vue, PropSync } from 'vue-property-decorator'
import { FeatureController } from '@/services/request.service'
import { getAgencyId } from '@/utils/utils'

@Component
export default class FeatureEditor extends Vue {
  @PropSync('features', { type: Array, default: () => ['GROTHMNT', 'NOTIFICA'] })
  private checkedFeatures!: Array<string>
  private featureData: Array<any> = [
    // 成长记录
    {
      slots: {
        title: 'moment',
      },
      disabled: true,
      key: 'GROTHMNT',
      children: [
        {
          slots: {
            title: 'comment',
          },
          key: 'COMMENT',
        },
        {
          slots: {
            title: 'parentMoment',
          },
          key: 'PUBGRMNT',
        },
      ],
    },
    // 评估
    {
      slots: {
        title: 'assessment',
      },
      key: 'ASSESSMT',
      children: [
        {
          slots: {
            title: 'assessmentSheet',
          },
          key: 'ASSSHEET',
        },
        {
          slots: {
            title: 'assessmentReport',
          },
          key: 'ASSREPOT',
        },
      ],
    },
    // 应用
    {
      slots: {
        title: 'application',
      },
      key: 'APPLIICA',
      children: [
        {
          slots: {
            title: 'attendance',
          },
          key: 'ATNDANCE',
        },
        {
          slots: {
            title: 'dailyCare',
          },
          key: 'RECORD',
        },
        {
          slots: {
            title: 'diary',
          },
          key: 'DIARY',
        },
        {
          slots: {
            title: 'sketch',
          },
          key: 'PALETTE',
        },
        {
          slots: {
            title: 'recipe',
          },
          key: 'RECIPE',
        },
        {
          slots: {
            title: 'album',
          },
          key: 'ALBUM',
        },
        {
          slots: {
            title: 'calendar',
          },
          key: 'CALENDER',
        },
        {
          slots: {
            title: 'leaveAudit',
          },
          key: 'LEAVE',
        },
        {
          slots: {
            title: 'mibp',
          },
          key: 'MULTIIBP',
        },
        {
          slots: {
            title: 'learningJournal',
          },
          key: 'LEARNJOUR',
        },
        {
          slots: {
            title: 'phdCourse',
          },
          key: 'PHDCOURSE',
        },
      ],
    },
    // 消息通知
    {
      slots: {
        title: 'message',
      },
      disabled: true,
      key: 'NOTIFICA',
      children: [
        {
          slots: {
            title: 'sendMessage',
          },
          key: 'SENDMESSAGE',
        },
        {
          slots: {
            title: 'replyMessage',
          },
          key: 'REPLYMESSAGE',
        },
      ],
    },
  ]

  private created(): void {
    this.getAvailableFeatures()
  }

  private getAvailableFeatures(): void {
    const agencyId = parseInt(getAgencyId(), 10)
    FeatureController.getFeaturesByAgency(agencyId)
      .then(res => {
        console.log('qqqqqq', res)
        // 筛选出返回的数据中的类似“notifica”这样的数据
        const availableFeatures = res.data.map(item => item.featureCode)
        // featureData是上面自己建立的key children
        const featureData = this.featureData
        for (let i in featureData) {
          let featureA = featureData[i]
          // console.log('featureA', featureA)
          // 如果请求数组不包含自己建立的数组父级的key 那么把这个key设置一个隐藏
          if (!availableFeatures.includes(featureA.key)) {
            featureA.invisible = true
          }
          // 循环自己建立的数组中的父级中的子级
          if (featureA.children && featureA.children.length) {
            for (let j in featureA.children) {
              let featureB = featureA.children[j]
              console.log('feaB', featureB)
              if (!availableFeatures.includes(featureB.key)) {
                featureB.invisible = true
              } else {
                const featureBList = [
                  'COMMENT',
                  'PUBGRMNT',
                  'ASSSHEET',
                  'ASSREPOT',
                  'ATNDANCE',
                  'RECORD',
                  'DIARY',
                  'PALETTE',
                  'RECIPE',
                  'ALBUM',
                  'CALENDER',
                  'LEAVE',
                  'MULTIIBP',
                  'LEARNJOUR',
                  'SENDMESSAGE',
                  'REPLYMESSAGE',
                ]
                if (featureBList.includes(featureB.key)) {
                  featureA.invisible = false
                }
              }
            }
          }
        }
        this.featureData = featureData
          .filter(item => !item.invisible)
          .map(item => {
            return {
              ...item,
              children: item.children?.filter(it => !it.invisible),
            }
          })
      })
      .catch(err => {
        console.error(err)
      })
  }

  private checkFeature(keys, e) {
    console.log('keys', keys)
    console.log('e', e)
    // 当前选中的key值
    const checkedKey = e.node.dataRef.key
    // 当前的改变是true选中，还是false取消选中
    const checked = e.checked
    if (checkedKey === 'GROTHMNT') {
      // 如果是取消选中
      if (!checked) {
        // keys是当前选中的所有的值的数组
        // newkeys筛选出
        const newKeys = keys.filter(
          key =>
            key !== 'ASSESSMT' &&
            key !== 'ASSSHEET' &&
            key !== 'ASSREPOT' &&
            key !== 'COMMENT' &&
            key !== 'PCOMMENT'
        )
        this.checkedFeatures = newKeys
        console.log('newkeys', newKeys)
        console.log('checkedFeatures', this.checkedFeatures)
        // 如果是选中 那么就直接加就行了
      } else {
        this.checkedFeatures = keys
      }
      //评论成长记录 /评估 /
    } else if (checkedKey === 'COMMENT' || checkedKey === 'ASSESSMT' || checkedKey === 'PCOMMENT') {
      if (checked) {
        const newKeys = keys.concat(['GROTHMNT'])
        this.checkedFeatures = newKeys
      } else {
        this.checkedFeatures = keys
      }
      // 评估表asssheet
    } else if (checkedKey === 'ASSSHEET') {
      if (checked) {
        // 成长记录
        const newKeys = keys.concat(['GROTHMNT'])
        this.checkedFeatures = newKeys
      } else {
        // 评估  评估报告
        const newKeys = keys.filter(key => key !== 'ASSESSMT' && key !== 'ASSREPOT')
        this.checkedFeatures = newKeys
      }
      // 评估报告
    } else if (checkedKey === 'ASSREPOT') {
      if (checked) {
        // 成长记录 评估表
        const newKeys = keys.concat(['GROTHMNT', 'ASSSHEET'])
        this.checkedFeatures = newKeys
      } else {
        this.checkedFeatures = keys
      }
    } else {
      this.checkedFeatures = keys
    }
  }
}
